import { createFileRoute, Link } from '@tanstack/react-router'
import { ArrowLeft } from 'lucide-react'

import { PageHeader } from '@/components/PageHeader'
import { Button } from '@/components/ui/button'
import { adminGetContent } from '@/lib/cms/admin/server'
import { ContentEditor } from './-components/content-editor'

export const Route = createFileRoute('/_authenticated/admin/content_/$id')({
  loader: ({ params }) => adminGetContent({ data: { id: params.id } }),
  component: EditContentPage,
})

function EditContentPage() {
  const doc = Route.useLoaderData()
  return (
    <div className="flex flex-col gap-6">
      <PageHeader
        title={doc.title}
        actions={
          <Button variant="outline" asChild>
            <Link to="/admin/content">
              <ArrowLeft data-icon="inline-start" />
              All content
            </Link>
          </Button>
        }
      />
      {/* Key on id + updatedAt so a fresh load (e.g. after publish) re-seeds
          the form state from the loader data. */}
      <ContentEditor
        key={`${doc.id}:${doc.updatedAt}`}
        kind={doc.kind}
        initial={doc}
      />
    </div>
  )
}
